exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attachment[data-v-456c5990]{height:46px;border-radius:5px}.pointer[data-v-456c5990]{cursor:pointer}", ""]);

// exports
